import axios from 'axios';

const BASE = '/api/membership-reminders';

const getExpiringSoon = async (projectId, page, records) => {
    const response = await axios.post(`${BASE}/get-expiring-soon`, { project_id: projectId, page, records });
    return response.data;
};

const getExpiringToday = async (projectId, page, records) => {
    const response = await axios.post(`${BASE}/get-expiring-today`, { project_id: projectId, page, records });
    return response.data;
};

const getRecentlyExpired = async (projectId, page, records) => {
    const response = await axios.post(`${BASE}/get-recently-expired`, { project_id: projectId, page, records });
    return response.data;
};

const getInactiveSubscribers = async (projectId, page, records) => {
    const response = await axios.post(`${BASE}/get-inactive-subscribers`, { project_id: projectId, page, records });
    return response.data;
};

const getCampaigns = async (projectId, page, records) => {
    const response = await axios.post(`${BASE}/get-campaigns`, { project_id: projectId, page, records });
    return response.data;
};

const createCampaign = async (data) => {
    const response = await axios.post(`${BASE}/create-campaign`, data);
    return response.data;
};

const updateCampaign = async (data) => {
    const response = await axios.post(`${BASE}/update-campaign`, data);
    return response.data;
};

const toggleCampaign = async (campaignId) => {
    const response = await axios.post(`${BASE}/toggle-campaign`, { campaign_id: campaignId });
    return response.data;
};

export default {
    getExpiringSoon,
    getExpiringToday,
    getRecentlyExpired,
    getInactiveSubscribers,
    getCampaigns,
    createCampaign,
    updateCampaign,
    toggleCampaign
};
